import React from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import ESimManagement from './subpages/ESimManagement'

let toggledWarningFromPrevLocation = false

interface LocationState {
  reason?: string | undefined
}

export default function ESimsManagementPage() {
  // reads the redirect error and toasts it to the client
  const location = useLocation()

  const state = location.state as LocationState
  if (state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(state.reason)
    delete state.reason
  }

  return (
    <PageLayoutV2 header='Manage Inventory'>
      <ESimManagement />
      {/* MAY REMOVE FULFILMENT PAGE AS NOT REQUIRED ANYMORE */}
      {/* <FulfilmentPage /> */}
    </PageLayoutV2>
  )
}
